import axios from "axios";
import config from "@/router/globalConfig";

export default {
    //============= Post API ===============

    //======================================
    //============== Get API ===============
    GetTitle(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetTitle', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetBank(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetBankList', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetDesig(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetDesigList', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetState(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetStateList', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    //======================================
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/applicationJS.js